import { apiUrl } from "../../../Constant/apiConstant"
import { getRequest, postFormRequest, postJsonRequest } from "../../../service/apiService"

export const getMarketetJobData = async (tenant: string | undefined, jobNum: number) => {
    try {
        const response = await getRequest(`${apiUrl.JM_GET_GET_MARKET_JOBDATA}/${jobNum}`, {}, tenant, true)

        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        console.log(error)
    }
    return null
}


export const postMarketJobData = async (tenant: string | undefined, jobTitle: string, jobNum: number,location:string) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_POST_MARKET_JOBDATA, { "JobNum": jobNum, "JobTitle": jobTitle,"Location":location }, tenant, true)
    } catch (error) {
        console.log(error)
    }
}

export const getUptoDateMarketJobData = async (tenant: string | undefined, payLoad:any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_GET_UPTODATE_MARKET_JOBDATA, payLoad, tenant, true)
        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const getJobs = async (tenant: string | undefined, payLoad: any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_GET_JOBS, payLoad, tenant, true)

        if (response.status === 200) {
            return response.data
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const deleteJob = async (tenant: string | undefined, payLoad: any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_POST_DELETE_JOB, payLoad, tenant, true)
        if (response.status === 200) {
            const {Status,Message}=response.data

            return {Status,Message}
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const getHiringFlow = async (tenant: string | undefined) => {
    try {
        const response = await getRequest(apiUrl.JM_GET_HIRING_FLOW, {}, tenant, true)

        if (response.status === 200) {
            const { Status, Data } = response.data

            if (Status) {
                return Data
            }
            return []
        }
    } catch (error) {
        console.log(error)
    }
    return []
}

export const getFormDropdowns = async (tenant: string | undefined) => {
    try {
        const response = await getRequest(apiUrl.JM_GET_FORM_DROPDOWNS, {}, tenant, true)

        if (response.status === 200) {
            const { Status, Currencies, JobTypes, JobPriorities } = response.data
            if (Status) {
                return {
                    Currencies: Currencies,
                    JobTypes: JobTypes,
                    JobPriorities: JobPriorities
                }
            }
            return null
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const getGeneratedJobPostingId = async (tenant: string | undefined, jobNum: any) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_GET_GENERATED_JOB_POSTING_ID, { JobNum: jobNum }, tenant, true)

        if (response.status === 200) {
            const { Status, JobPostingId } = response.data


            if (Status) {
                return JobPostingId
            }
            return null
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const getJobDetails = async (tenant: string | undefined, jobNum: number) => {
    try {
        const response = await getRequest(`${apiUrl.JM_GET_JOB_DETAILS}/${jobNum}`, {}, tenant, true)

        if (response.status === 200) {
            const { Status, JobData, ExtraFields, Logo } = response.data

            if (Status) {
                return { JobData: JobData, ExtraFields: ExtraFields, Logo: Logo }
            }
            return null
        }
    } catch (error) {
        console.log(error)
    }
    return null
}

export const getJobFields = async (tenant: string | undefined, jobNum: number) => {
    try {
        const response = await getRequest(`${apiUrl.JM_GET_JOB_FIELDS}/${jobNum}`, {}, tenant, true)

        if (response.status === 200) {
            const { Status, Data } = response.data

            if (Status) {
                return Data
            }
            return []
        }
    } catch (error) {
        console.log(error)
    }
    return []
}

export const uploadJobLogo = async (tenant: string | undefined, jobNum: number, file: any) => {
    try {
        const formData = new FormData();
        formData.append("JobNum", jobNum.toString());
        formData.append("Logo", file);

        const response = await postFormRequest(apiUrl.JM_POST_UPLOAD_JOB_LOGO, formData, tenant, true);

        if (response.status === 200) {
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
    return null;
}

export const exportJobData = async (tenant: string | undefined, payLoad: any, jobTitle: string) => {
    try {
        const response = await postJsonRequest(apiUrl.JM_GET_EXPORT_JOB_DATA, payLoad, tenant, true, "blob")

        if (response.status === 200) {
            const blob = new Blob([response.data]);
            const format = payLoad.format || "pdf";
            const jobNum = payLoad.JobNum || "Job";
            const fileName = `${jobTitle}.${format}`;

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        }
    } catch (error) {
        console.log(error)
    }
}

export const getCandidateSummaryByJobNum = async (tenant: string | undefined,payLoad:any) =>{
    try{
        const response = await postJsonRequest(apiUrl.JM_GET_CANDIDATE_SUMMARY_BY_JOB,payLoad,tenant,true)

        if(response.status === 200){
            const {Status,Data,Total}=response.data

            return Status ? {Data,Total} : null
        }
    }catch(error){
        console.log(error)
    }

    return null
}

export const getCandidatesByStatus = async (tenant: string | undefined,payLoad: any) => {
    try{
        const response = await postJsonRequest(apiUrl.JM_GET_CANDIDATES_BY_STATUS,payLoad,tenant,true)

        if(response.status === 200){
            const {Status,Data} = response.data

            return Status ? Data : []
        }
    }catch(error){
        console.log(error)
    }
    return []
}

export const deleteJobLogo = async (tenant: string | undefined,payLoad:any)=>{
    try{
        const response = await postJsonRequest(apiUrl.JM_POST_DELETE_JOB_LOGO,payLoad,tenant,true)

        if(response.status === 200){
            const {Status} = response.data

            return Status
        }
    }catch(error){
        console.log(error)
    }

    return false

}